// --- React & Redux
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
// --- Auth/Routing Dependencies
import { initialize } from './store/auth';
import { Router } from '@reach/router';
// --- Components
import { Header } from './components/Header';
import { Spinner } from './components/Spinner';
import { PageNavigation } from './components/PageNavigation';
import { DialogsProvider } from './components/dialogs';
// --- Pages
import { ProductsPage } from './pages/Products';
import { ClearanceMemoTitlesPage } from './pages/ClearanceMemoTitles';
import { SharedSectionsPage } from './pages/SharedSections';
import { ContactsPage } from './pages/Contacts';
import { TagsPage } from './pages/Tags';

/**
 * ClearanceMemoRouter Component
 *
 * This component is responsible for rendering the main application layout,
 * including the header, spinner, and routing for different pages.
 * It initializes the application state and provides a context for dialogs.
 *
 * @component
 * @returns {JSX.Element} The complete application layout with routing.
 */
export default function ClearanceMemoRouter() {
    const dispatch = useDispatch();

    // Initialize the application state
    useEffect(() => {
        dispatch(initialize());
    }, [dispatch]);

    return (
        <>
            <Spinner />
            <Header />
            <DialogsProvider>
                <PageNavigation>
                    <Router>
                        <ProductsPage path="/products" />
                        <ClearanceMemoTitlesPage path="/clearanceMemoTitles" />
                        <SharedSectionsPage path="/sharedSections" />
                        <ContactsPage path="/contacts" />
                        <TagsPage path="/tags" />
                    </Router>
                </PageNavigation>
            </DialogsProvider>
        </>
    );
}
